"use client";
import React, { useEffect, useState } from "react";
import Link from "next/link";
import Image from "next/image";
import HomeVideoPoster from "@/Helper/images/homepageimg/home_bannerbg.webp";
import YearsGoldImg from "@/Helper/images/new/years_logo_gold.svg";

const Counter = ({ endValue, duration }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let startValue = 0;
    const stepTime = (duration * 1000) / endValue; // Convert to milliseconds

    const counter = setInterval(() => {
      setCount((prevCount) => {
        if (prevCount < endValue) {
          return prevCount + 1;
        } else {
          clearInterval(counter);
          return endValue;
        }
      });
    }, stepTime);

    return () => clearInterval(counter);
  }, [endValue, duration]);

  return <span>{count} +</span>;
};
const Banner = () => {
  return (
    <div className="homebanner_section">
      <video
        className="appi_intro_video lazy-video"
        poster={HomeVideoPoster}
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
      >
        <source
          src="https://res.cloudinary.com/dxrr6p1eq/video/upload/v1750924708/jorxyhducuqryv6imygj.mp4"
          type="video/mp4"
        />
        <track
          src="/captions_en.vtt"
          kind="captions"
          srclang="en"
          label="English Captions"
        />
      </video>

      <div className="container">
        <div className="homebannerinner row">
          <div className="homebannerinnerbx">
            <div className="hm_bannerlft">
              {/* <span class="banner_subhd">
                Drive Innovation with Flexibility
              </span> */}

              <p className="banner_hd">
                Transmitting Rotary Motion?
                <br/> We're Flexible.
              </p>
              <p className="banner_bannercont">
                Flexible shaft technology provides versatile and efficient power <br/> transmission in tight spaces. It ensures reliable performance with  <br/>  precision engineering for various industrial applications.
              </p>

              <div className="home_linksbtn">
                <Link
                  href="/about-us"
                  className="btn btn-primary"
                  aria-label="Explore Aspino"
                >
                  About Us <span className="bannerbutton_arrow"></span>
                </Link>
                {/* <Link
                  href="/careers"
                  className="btn btn-secondary"
                  aria-label="Transform your career"
                >
                  Transform your career{" "}
                  <span className="bannerbutton_arrow"></span>
                </Link> */}
              </div>
            </div>
            <div className="hm_bannergt">
              <div className="hm_bannergtimgbx">
                <Image
                  src={YearsGoldImg}
                  alt="180 years gold"
                  width={250}
                  height={100}
                />
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
